module.exports = __webpack_public_path__ + "static/media/boy-8.c6de28b9.svg";